/**
 * Shared configuration for the Google Maps JavaScript API across the consumer
 * app on the `@vis.gl/react-google-maps` (flag-ON) path.
 *
 * vis.gl keeps a module-level singleton of the params the API was first loaded
 * with, so every `<APIProvider>` must request the SAME `libraries` set —
 * otherwise SPA navigation between routes logs "The Google Maps JavaScript API
 * has already been loaded with different parameters". These constants keep every
 * provider call site (and the Advanced-Marker map ID) in lockstep.
 */

/**
 * Superset of libraries used anywhere in consumer. vis.gl lazy-loads each
 * library on demand via `google.maps.importLibrary(name)`, so listing the
 * superset everywhere is a negligible one-time preload with zero billing impact.
 * `places` powers autocomplete, `marker` powers `<AdvancedMarker>`, and `maps`
 * is the core map + geometry helpers.
 */
export const MAP_LIBRARIES: string[] = ['places', 'marker', 'maps'];

/**
 * Map ID required by Advanced Markers (`<AdvancedMarker>`). Reuses the consumer
 * map ID already in production (`ConsumerMap`), so styling is unchanged. Swap
 * for a cloud-styled Map ID if custom branding is ever wanted.
 */
export const MAP_ID = '52ad3d2f91d95eb5';
